import { SelectData } from "../../models";

export class ProjectDatesConstants {
  public static readonly FEASIBILITY_START_TOOLTIP_TEXT =
    "When the project is conceived and feasibility analysis begins.";

  public static readonly FEASIBILITY_END_TOOLTIP_TEXT =
    "When the project is deemed feasible and the design process can begin.";

  public static readonly DESIGN_START_TOOLTIP_TEXT =
    "When the project is deemed feasible and the design process begins.";

  public static readonly DESIGN_END_TOOLTIP_TEXT =
    "When the design plans of the project are implemented, usually marking the beginning of site preparation.";

  public static readonly DESIGN_REGISTRATION_DATE_TOOLTIP_TEXT =
    "The date the project was registered with the external registry.";

  public static readonly IMPLEMENTATION_START_TOOLTIP_TEXT =
    "When the design plans of the project are implemented, usually marking the beginning of site preparation.";

  public static readonly IMPLEMENTATION_END_TOOLTIP_TEXT =
    "When the implementation of the project is completed, usually marked by successful validation.";

  public static readonly IMPLEMENTATION_IMPLEMENTATION_DATE_TOOLTIP_TEXT =
    "The date project activities started on site.";

  public static readonly IMPLEMENTATION_CERTIFICATION_DATE_TOOLTIP_TEXT =
    "The project has been certified by the Technical Standards Board and work may begin.";

  public static readonly IMPLEMENTATION_RESTORATION_VALIDATION_DATE_TOOLTIP_TEXT =
    "The date the initial restoration activities of the project have been verified.";

  public static readonly IMPLEMENTATION_START_DATE_TOOLTIP_TEXT = "The date project activities are finished on site.";

  public static readonly IMPLEMENTATION_FIRST_ASSESSMENT_DATE_TOOLTIP_TEXT =
    "The first verification of the project, ensuring the activities on the project site meet the requirements of the standard.";

  public static readonly IMPLEMENTATION_DURATION_TOOLTIP_TEXT = "The total length of the project lifetime in years.";

  public static readonly ONGOING_MONITORING_START_TOOLTIP_TEXT =
    "The beginning of the ongoing monitoring period, marked by the first validation.";

  public static readonly ONGOING_MONITORING_END_TOOLTIP_TEXT =
    "This is the project's end date, usually calculated by adding the project duration to the project start date.";

  public static readonly ONGOING_MONITORING_SECOND_ASSESSMENT_DATE_TOOLTIP_TEXT =
    "The date of the next project assessment after validation, usually called 'Verification'.";

  public static readonly ONGOING_MONITORING_FINAL_ASSESSMENT_DATE_TOOLTIP_TEXT =
    "The date of the final project assessment, making the last vintage of the project's units.";

  public static readonly ONGOING_MONITORING_SUBSEQUENT_FREQUENCY_TOOLTIP_TEXT =
    "The frequency of the project assessment dates happening after the second assessment.";

  public static readonly ONGOING_MONITORING_CYCLE_START_TOOLTIP_TEXT =
    "The start date of the current monitoring cycle.";

  public static readonly ONGOING_MONITORING_CYCLE_END_TOOLTIP_TEXT = "The end date of the current monitoring cycle.";

  public static readonly ONGOING_MONITORING_CYCLE_ASSESSMENT_TOOLTIP_TEXT =
    "The assessment date of the current monitoring cycle.";

  public static readonly ONGOING_MONITORING_SUBSEQUENT_FREQUENCY_SELECT_DATA = [
    { value: "Annually", key: 1 },
    { value: "5-yearly", key: 5 },
    { value: "10-yearly", key: 10 },
  ] as SelectData;
}
